import SqFetch from 'typescript/application/sq_fetch';
import { _handleResponse } from 'typescript/clients/utilities/handle_http_response';

// functions are controlled by the methods in this controller
// app/controllers/sq/api/products_controller.rb

export const PRODUCTS_BASE_URL = '/shop/api/v1/products';

/**
 * Get add-ons for a specific product
 * @param productSlug - the product slug identifier
 * @param locale - the locale for the request
 * @param options - optional parameters for the request
 * @returns add-ons data for the specified product
 */
export const getProductAddOns = async ({
  productSlug,
  locale,
  options,
}: {
  productSlug: string;
  locale: string;
  options?: any;
}): Promise<any> => {
  const response = await SqFetch.post(
    `${PRODUCTS_BASE_URL}/${productSlug}/add_ons`,
    {
      locale,
      options,
    },
  );

  return _handleResponse(response);
};
